export default __webpack_public_path__ + "static/testimonial-bg-desktop-light-ae1369fe2a2f1d6aa1368011f5e8ca77.png";